import { format } from 'date-fns';
import { ISO_DATE_FORMAT } from '@constants/dates';

/**
 * Creates a rollup window key for a given start date and end date.
 *
 * @return {string} Returns rollup window key representing start and end date.
 */
export const createWindowKey = (startDate: Date, endDate: Date): string =>
  `${format(startDate, ISO_DATE_FORMAT)}-${format(endDate, ISO_DATE_FORMAT)}`;
